import * as React from 'react';
import * as DTO from '../service/DTOs';
import * as TF from '../service/tradeflow';
import * as RB from 'react-bootstrap';
import * as Actions from '../service/Actions';
import * as Dispatch from '../service/Dispatcher';
import * as Intl from 'react-intl'

import 'isomorphic-fetch';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

import DateRangePicker from 'react-bootstrap-daterangepicker';
import { ContragentPopoverInfo } from './view/helpers/ContragentPopoverInfo'

import { Modal } from 'react-bootstrap';
import { dateFormat } from '../service/tradeflow';
import moment from 'moment';

import { LineSpinner } from './shared/effects/LineSpinner'
//import * as MD from 'react-md'

import { SpinnerBlock } from './shared/effects/Spinners'
const iconSpinner = <SpinnerBlock />




interface MyDealsState {
    records?: DTO.RecordOrder[];
    loading: boolean;
    syshdr?: DTO.SystemHeader;
    ds?: DTO.AgentDSMyDealsGroup;
    processing?: boolean;
    selected_locatorId?: string;
    showContragentInfo: boolean;
    context?: DTO.RecordOrder;
}

type MyDealsProps = MyDealsState & { xsrfToken?: string };

const initialstate: MyDealsState = {
    records: [],
    loading: true,
    showContragentInfo: false
}


export class MyDealsComponent extends React.Component<MyDealsProps, MyDealsState> {
    dateRange: ReactBootstrapDaterangepicker.DateRangePicker | null;
    constructor(props: MyDealsProps) {
        super(props);
        this.state = {
            ...initialstate, ...{ records: props.records, syshdr: props.syshdr, ds: props.ds }
        };
    }

    processOrderBookRecords(data: DTO.OrderBookRecords) {
        if (this.refs.cmpMyDealsRef) {
            this.setState({
                records: data.ordbook_records,
                loading: false,
                processing: false
            });
        }

        return { return: 0 };
    }

    componentWillReceiveProps(nextProps: MyDealsProps) {
        this.setState({ ds: nextProps.ds });
    }

    componentDidMount() {
        TF.DataProcessBinding(this, { type: 'DATA.updatemydeals', delegate: this.processOrderBookRecords });
    }

    dispatch = (action: Actions.OrderAction) => {
        return Dispatch.OrderDispatcher(this, action);
    }

    handleSelectContext(locatorId?: string, record?: DTO.RecordOrder) {
        this.setState({
            selected_locatorId: locatorId
        });


        let uiCtx: DTO.UserInteractionContext = {
            selected_cmp: this,
            selected_locatorId: locatorId
        }

        TF.PublishCommand('COMMAND.UI.UserInteractionCtx', uiCtx);

        if (locatorId && record) {
            let nOrder: DTO.NewOrder = record.proto;

            TF.PublishCommand('COMMAND.NewOrderFromTemplate', nOrder);
        }
    }

    handleDealInfoClicked(locatorId?: string, record?: DTO.RecordOrder) {

        //console.log('record');
        //console.log(record);
        
        this.setState({ context: record, showContragentInfo: true});
    }

    handleModalClose() {
        this.setState({ showContragentInfo: false, context: undefined});
    }


    filterRangeSetupToday(event: any) {
        if (this.props.ds) {
            this.setState({ processing: true });

            let dsFilter: DTO.AgentDSPeriodFilter = { ...this.props.ds.periodFilter, ...{ isCurrentPeriod: true } };
            TF.PublishCommand('COMMAND.State.AgentDSPeriodFilterMyDeals', dsFilter);
        }

        event.preventDefault();
    }

    filterRangeSetupPeriod(event: any) {
        if (this.props.ds) {
            this.setState({ processing: true });

            let dsFilter: DTO.AgentDSPeriodFilter = { ...this.props.ds.periodFilter, ...{ isCurrentPeriod: false } };
            TF.PublishCommand('COMMAND.State.AgentDSPeriodFilterMyDeals', dsFilter);
        }

        event.preventDefault();
    }

    filterRangeApply(event: any, picker: any) {

        if (this.props.ds) {
            this.setState({ processing: true });

            let dsFilter: DTO.AgentDSPeriodFilter = { ...this.props.ds.periodFilter, ...{ startDateIncl: picker.startDate, finishDateIncl: picker.endDate, isCurrentPeriod: false } };
            TF.PublishCommand('COMMAND.State.AgentDSPeriodFilterMyDeals', dsFilter);
        }


        return {};

    }

    public render() {
        let contents = this.state.loading
            ? <div>{iconSpinner}</div>
            : (this.state.records ? this.renderMyDealsTable(this.state.records, this.state.processing ? this.state.processing : false) : this.renderMyDealsTable([], false));


        let filterCnt = undefined;
        if (this.props.ds) {
            if (!this.props.ds.periodFilter.startDateIncl && !this.props.ds.periodFilter.finishDateIncl)
                filterCnt = undefined;
            else {

                let sts = this.props.ds.periodFilter.startDateIncl ? moment(this.props.ds.periodFilter.startDateIncl).format('DD.MM.YYYY') : '';
                let fts = this.props.ds.periodFilter.finishDateIncl ? moment(this.props.ds.periodFilter.finishDateIncl).format('DD.MM.YYYY') : '';

                filterCnt = <RB.Button bsStyle={this.props.ds.periodFilter.isCurrentPeriod ? 'default' : 'success'} onClick={this.filterRangeSetupPeriod.bind(this)} > {sts + ' - ' + fts}</RB.Button >;
            }
        }

        let hdrContent = <div><b>Мои сделки: </b>{this.state.records && this.state.records.length > 0 ? '' + this.state.records.length + ' элемент(ов) ' : ' нет элементов '} </div>

        return <div ref="cmpMyDealsRef" >
            <RB.Row>
                <RB.Col sm={12}>
                    <RB.Well bsSize="sm" className="well-sm-smaller">
                        <RB.ButtonToolbar className="rep_welltitle">
                            <RB.ButtonGroup bsSize="xsmall">
                                {hdrContent}
                            </RB.ButtonGroup>
                            <RB.ButtonGroup bsSize="xsmall">
                                <RB.Button bsStyle={this.props.ds ? this.props.ds.periodFilter.isCurrentPeriod ? 'success' : 'default' : 'default'} onClick={this.filterRangeSetupToday.bind(this)}>{'Today'}</RB.Button>
                                {filterCnt}
                            </RB.ButtonGroup>

                            <RB.ButtonGroup bsSize="xsmall">
                                <DateRangePicker ref={(dateRange) => this.dateRange = dateRange}
                                    onApply={this.filterRangeApply.bind(this)}
                                    showCustomRangeLabel={false} applyClass='btn-primary'
                                    alwaysShowCalendars={true} linkedCalendars={true}
                                    opens={'left'} drops={'up'}
                                    locale={{
                                        format: 'DD.MM.YYYY', applyLabel: 'Выбрать', cancelLabel: 'Отменить', customRangeLabel: 'За период ...',
                                        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                                        firstDay: moment.localeData('ru-RU').firstDayOfWeek(),
                                        daysOfWeek: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
                                    }}
                                    ranges={{
                                        'Сегодня': [moment(), moment()],
                                        'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                        'С начала месяца': [moment().startOf('month'), moment().endOf('month')],
                                        'За месяц': [moment().subtract(1, 'month'), moment()]
                                    }}
                                >
                                    <RB.ButtonGroup bsSize="xsmall">
                                        <RB.Button id='filterRangeSetup' title='Настроить фильтр'><RB.Glyphicon glyph="filter" /></RB.Button>
                                    </RB.ButtonGroup>

                                </DateRangePicker>
                            </RB.ButtonGroup>

                        </RB.ButtonToolbar>

                        <div>{contents}</div>
                    </RB.Well>
                </RB.Col>
            </RB.Row>
        </div>;
    }
    

    private renderMyDealsTable(records: DTO.RecordOrder[], processing: boolean, selected_locatorId?: string) {
        let modalCnt = <span></span>;
        if (this.state.context && this.state.context.contragent_info) {

            modalCnt = <div>
                <span><b>Карточка юридического лица</b></span>
                <table className='table table-condensed' >
                    <tbody>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Название: '}</td>
                            <td>{this.state.context.contragent_info.fullname}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Краткое название: '}</td>
                            <td>{this.state.context.contragent_info.shortname}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Reuter Code: '}</td>
                            <td>{this.state.context.contragent_info.reutercode }</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Bloobmerg Code: '}</td>
                            <td>{this.state.context.contragent_info.bloombergcode}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Юридический адрес: '}</td>
                            <td>{this.state.context.contragent_info.addresslegal}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Факт. адрес: '}</td>
                            <td>{this.state.context.contragent_info.addressfact}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Телефон: '}</td>
                            <td>{this.state.context.contragent_info.phone ? this.state.context.contragent_info.phone: '-'}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Факс: '}</td>
                            <td>{this.state.context.contragent_info.fax ? this.state.context.contragent_info.fax : '-'}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Email: '}</td>
                            <td>{this.state.context.contragent_info.email ? this.state.context.contragent_info.email : '-'}</td>
                        </tr>
                    </tbody>
                </table>
                <span><b>Трейдер</b></span>
                <table className='table table-condensed' >
                    <tbody>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'ФИО: '}</td>
                            <td>{this.state.context.trader.lastName}{' '}{this.state.context.trader.firstName}{' '}{this.state.context.trader.sureName}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Телефон: '}</td>
                            <td>{this.state.context.trader.phoneNumber}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'email: '}</td>
                            <td>{this.state.context.trader.email}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Доп. информация: '}</td>
                            <td>{this.state.context.trader.contactInfo}</td>
                        </tr>
                    </tbody>
                </table>

            </div>;
        }

        return <div>
            <Modal show={this.state.showContragentInfo} onHide={this.handleModalClose.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>Контрагент</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalCnt}
                </Modal.Body>
                <Modal.Footer>
                    <RB.Button onClick={this.handleModalClose.bind(this)}>Закрыть</RB.Button>
                </Modal.Footer>
            </Modal>
            <table className='table table-header-fixed table-condensed' >
                <thead>
                    <tr style={{ width: 'calc(100% - 10px)' }}>
                        <th style={{ textAlign: 'right', width: '12%' }}>№ заявки</th>
                        <th style={{ textAlign: 'right', width: '10%' }}>Контрагент</th>
                        <th style={{ textAlign: 'right', width: '7%' }}>Тип</th>
                        <th style={{ textAlign: 'right', width: '7%' }}>Срок</th>
                        <th style={{ textAlign: 'right', width: '15%' }}>Сумма</th>
                        <th style={{ textAlign: 'right', width: '8%' }}>Валюта</th>
                        <th style={{ textAlign: 'right', width: '12%' }}>Ставка, %</th>
                        <th style={{ textAlign: 'right', width: '12%' }}>Дисконт, %</th>
                        <th style={{ textAlign: 'right', width: '17%' }}>Тикер</th>
                    </tr>
                </thead>
                <tbody style={{ height: '170px' }}>
                    {records.map(orderrecord =>
                        <OrderRecord key={orderrecord.manipulation.locatorId} record={orderrecord} xsrfToken={this.props.xsrfToken} {...initialstate_orderrecord} modified={orderrecord.manipulation.justChanged ? orderrecord.manipulation.justChanged : false}
                            processing={processing} dealInfoClicked={this.handleDealInfoClicked.bind(this)} orderSelected={this.handleSelectContext.bind(this)} selected={this.state.selected_locatorId == orderrecord.manipulation.locatorId} />
                    )}
                </tbody>
            </table>
        </div>;
    }
}


type OrderRecordProps = Actions.OrderState & { xsrfToken?: string } & { record: DTO.RecordOrder } & { orderSelected: any } & { dealInfoClicked: any};

const initialstate_orderrecord: Actions.OrderState = {
    processing: false,
    haserrors: false,
    modified: false,
    selected: false
}



class OrderRecord extends React.Component<OrderRecordProps, Actions.OrderState> {
    constructor(props: OrderRecordProps) {
        super(props);
        this.state = {
            ...initialstate_orderrecord, ...{ processing: props.processing, haserrors: props.haserrors, modified: props.modified }
        };
    }

    dispatch = (action: Actions.OrderAction) => {
        return Dispatch.OrderDispatcher(this, action);
    }


    _popup_contragent_info = (locatorId: string, record: DTO.RecordOrder) => {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_CONTEXT,
            locatorId: locatorId,
            payload: undefined
        }

        return this.props.dealInfoClicked(locatorId, record);        
    }

    //_repeal = (locator: { locatorId: string }) => {
    //    //console.log('_repeal = ');
    //    //console.log(locator);

    //    let manipulation: DTO.ManipulationAction<string> = {
    //        locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
    //        type: DTO.MANIPULATION_PERM_REPEAL,
    //        locatorId: locator.locatorId,
    //        payload: undefined
    //    }

    //    return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
    //}

    componentWillReceiveProps(nextProps: OrderRecordProps) {
        this.setState(nextProps);
    }

    _onSelectOrder = (locatorId: string, record: DTO.RecordOrder) => {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_CONTEXT,
            locatorId: locatorId,
            payload: undefined
        }

        return this.props.orderSelected(locatorId, record);
        //return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
    }

    public render() {
        //console.log(this.props.record.manipulation);
        //let bg_color = this.state.modified ? '#9be8d7' : (this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white'));
        let bg_color = this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white');
        //let row_border = this.state.selected ? { borderStyle: 'solid', borderWidth: '2.5px' } : { borderStyle: 'none'};

        let crsr = this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ? { cursor: 'pointer' } : { cursor: 'default' };

        let animation_mod = this.state.modified ? { animation: 'newdata_blink_green 2s 5' } : {}

        var trStyle = {
            //...{ backgroundColor: bg_color }, ...row_border, ...crsr
            ...{ backgroundColor: bg_color }, ...crsr, ...animation_mod
        };

        var trClass: string = (this.state.selected ? 'rowselected' : '');

        let popoverContragent =
            this.props.record.contragent_info ?
                (
                    <RB.Popover id="popover-contragentInfo" title={this.props.record.contragent_info.fullname} style={{ minWidth: '400px', fontSize: '12px'  }}>
                        <div> 
                            <ul>
                                <li>
                                    <strong>{'Название: '}</strong>{this.props.record.contragent_info.fullname}
                                </li>
                                <li>
                                    <strong>{'Краткое название: '}</strong>{this.props.record.contragent_info.shortname}
                                </li>
                                <li>
                                    <strong>{'Reuter Code: '}</strong>{this.props.record.contragent_info.reutercode}
                                </li>
                                <li>
                                    <strong>{'Blomberg Code: '}</strong>{this.props.record.contragent_info.bloombergcode}
                                </li>
                                <li>
                                    <strong>{'Юридический адрес: '}</strong>{this.props.record.contragent_info.addresslegal}
                                </li>
                                <li>
                                    <strong>{'Факт. адрес: '}</strong>{this.props.record.contragent_info.addressfact}
                                </li>
                                <li>
                                    <strong>{'Телефон: '}</strong>{this.props.record.contragent_info.phone ? this.props.record.contragent_info.phone : '-'}
                                </li>
                                <li>
                                    <strong>{'Факс: '}</strong>{this.props.record.contragent_info.fax ? this.props.record.contragent_info.fax : '-'}
                                </li>
                                <li>
                                    <strong>{'Email: '}</strong>{this.props.record.contragent_info.email ? this.props.record.contragent_info.email : '-'}
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="popover-title" style={{ margin: "0px -15px 0px -15px" }}>Трейдер</h3>
                            <ul>
                                <li>
                                    <strong>{'ФИО: '}</strong>{this.props.record.trader.lastName}{' '}{this.props.record.trader.firstName}{' '}{this.props.record.trader.sureName}
                                </li>
                                <li>
                                    <strong>{'Телефон: '}</strong>{this.props.record.trader.phoneNumber}
                                </li>
                                <li>
                                    <strong>{'email: '}</strong>{this.props.record.trader.email}
                                </li>
                                <li>
                                    <strong>{'Доп. информация: '}</strong>{this.props.record.trader.contactInfo}
                                </li>
                            </ul>
                        </div>
                    </RB.Popover>
                ) : undefined;

        //let contragentToolTip = this.props.record.contragent_info
        //    ? 
        //    : undefined;

        //<RB.OverlayTrigger
        //    trigger={['hover', 'focus']}
        //    placement="top"
        //    overlay={popoverContragent}
        //>
        //    <div>{this.props.record.contragent}</div>
        //</RB.OverlayTrigger>

        return <tr key={this.props.record.manipulation.locatorId} className={trClass} style={trStyle} onClick={this._onSelectOrder.bind(this, this.props.record.manipulation.locatorId, this.props.record)}>
            <td style={{ textAlign: 'right', width: '12%' }} >
                {this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ?
                    <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                        <RB.Button title='Инфо' disabled={this.state.processing} onClick={this._popup_contragent_info.bind(this, this.props.record.manipulation.locatorId, this.props.record )}><RB.Glyphicon glyph="phone" /></RB.Button>
                    </RB.ButtonGroup>
                    : ''
                }
                {this.props.record.orderno}
            </td>
            <td style={{ textAlign: 'right', width: '10%' }}>
        <RB.OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="top"
                    overlay={popoverContragent}
                    delayShow={500}                    
                >
                    <div className="text-popover-marker">{this.props.record.contragent}</div>
        </RB.OverlayTrigger>

                
            </td>
            <td style={{ textAlign: 'right', width: '7%' }} > {this.props.record.lottype}</td>
            <td style={{ textAlign: 'right', width: '7%' }} > {this.props.record.duration}</td>
            <td style={{ textAlign: 'right', width: '15%' }} > {<Intl.FormattedNumber value={this.props.record.sum} minimumFractionDigits={0} maximumFractionDigits={0} />} </td>
            <td style={{ textAlign: 'right', width: '8%' }} > {this.props.record.lotcurrency}</td>
            <td style={{ textAlign: 'right', width: '12%' }} > {<Intl.FormattedNumber value={this.props.record.rate / 100.0} style="percent" minimumFractionDigits={2} maximumFractionDigits={2} />}</td>
            <td style={{ textAlign: 'right', width: '12%' }} > {<Intl.FormattedNumber value={this.props.record.discount / 100.0} style="percent" minimumFractionDigits={2} maximumFractionDigits={2} />}</td>
            <td style={{ textAlign: 'right', width: '17%' }} > {this.props.record.secticker}</td>
        </tr>
            ;
    }

}

